import * as angular from 'angular';

import { Miniature } from '../../models';
import { IConfigurationService } from '../../services';
import { IUser } from '../../models';

export interface IUserFactory {
    createUser(): any;
    getMiniatureList(): Miniature[];
}

export class UserFactory implements IUserFactory {

    static serviceId = 'userFactory';

    userTypes: Miniature[];

    private _blank: Miniature;
    private _domain: Miniature;
    private _uploadUser: Miniature;

    static $inject = ['configurationService'];

    constructor(private _configurationService: IConfigurationService) {
        try {
            this._blank = new Miniature('addUser', 'Local user', 'fa-user', ['Create a new local user']);
            this._domain = new Miniature('addDomainUser', 'Domain user', 'fa-windows', ['Import a domain user from your Active Directory']);
            this._uploadUser = new Miniature('uploadUserFile', 'Import users', 'fa-users', ['Import or update users from a CSV file']);
            this.userTypes = [this._blank];
            if (this._configurationService) {
                this._configurationService
                    .getApiInformation()
                    .then(info => {
                        if (info.isInDomain) {
                            this.userTypes.push(this._domain);
                        }
                        this.userTypes.push(this._uploadUser);
                    });
            }
        } catch (e) {
            console.error(e);
            this.userTypes = [];
        }
    }

    createUser(): any {
        const user: IUser = <IUser>{};
        return user;
    }

    getMiniatureList(): Miniature[] {
        return this.userTypes;
    }
}